package com.ijoin.util.datetime

import com.ijoin.platform.createTimeZone
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.LocalTime
import kotlinx.datetime.TimeZone

fun combineDateAndTime(date: LocalDate, timeString: String?): LocalDateTime {
    val time = timeString?.takeIf { it.isNotBlank() }?.let {
        runCatching { LocalTime.parse(it) }.getOrNull()
    }
    val hour = time?.hour ?: 0
    val minute = time?.minute ?: 0
    return LocalDateTime(
        year = date.year,
        monthNumber = date.monthNumber,
        dayOfMonth = date.dayOfMonth,
        hour = hour,
        minute = minute,
        second = 0,
        nanosecond = 0,
    )
}

fun parseTimeZoneOrDefault(timeZoneId: String?): TimeZone =
    if (!timeZoneId.isNullOrBlank()) createTimeZone(timeZoneId) else TimeZone.currentSystemDefault()

